"use client";

import { mapSrcLinks } from "@/config/mapSrcConfig";
import { theme } from "@/config/theme";
import { appSelectedCountry } from "@/recoil/appState";
import { shouldRenderLocationMapIframe } from "./locationMapVisibility";
import { useEffect, useRef, useState } from "react";
import { useRecoilValue } from "recoil";
import styled from "styled-components";

const LocationMap = () => {
    const selectedCountry = useRecoilValue(appSelectedCountry);
    const containerRef = useRef<HTMLDivElement>(null);
    const [hasRequestedMap, setHasRequestedMap] = useState(false);
    const mapSrc = mapSrcLinks.find(
        (item) => item.country === selectedCountry
    )?.link;
    const shouldRenderIframe = shouldRenderLocationMapIframe(hasRequestedMap);

    useEffect(() => {
        if (hasRequestedMap) {
            return;
        }

        const container = containerRef.current;
        if (!container || !("IntersectionObserver" in window)) {
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setHasRequestedMap(true);
                    observer.disconnect();
                }
            },
            { rootMargin: "600px 0px" }
        );

        observer.observe(container);

        return () => {
            observer.disconnect();
        };
    }, [hasRequestedMap]);

    return (
        <SCLocationMap ref={containerRef}>
            {shouldRenderIframe && mapSrc ? (
                <iframe
                    src={mapSrc}
                    width="100%"
                    height="630"
                    loading="lazy"
                    title="Swimming Pool Locations Map"
                ></iframe>
            ) : (
                <div className="map-placeholder">
                    <button
                        type="button"
                        onClick={() => setHasRequestedMap(true)}
                    >
                        View map
                    </button>
                </div>
            )}
        </SCLocationMap>
    );
};

export default LocationMap;

const SCLocationMap = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    // padding: ${theme["spacing-lxl"]} 0
    //     ${theme["spacing-lxl"]};
    background-color: #bff5ff;

    .map-placeholder {
        align-items: center;
        background: #dff9ff;
        display: flex;
        height: 630px;
        justify-content: center;
        width: 100%;
    }

    .map-placeholder button {
        background: ${theme["color-blue"]};
        border: 0;
        border-radius: 999px;
        color: ${theme["color-white"]};
        cursor: pointer;
        font-family: inherit;
        font-size: ${theme["fontsize-m"]};
        padding: ${theme["spacing-sm"]} ${theme["spacing-ml"]};
    }
`;
